//=================================\\
// Jobs Frame Settings \\
//=================================\\

export default function jobsFrame() {
	$(".resumator-hide-details").on("click", function () {
		let typeOfJob = $('.resumator-job.resumator-jobs-text').position().top;

		$('html, body').scrollTop(typeOfJob - 150);


		if ($(".resumator-job-view-details").hasClass("active")) {
			$(".resumator-job-view-details").removeClass("active");
		}
	});
}



// WEBPACK FOOTER //
// ./scripts/modules/jobs-frame.js